/** Trusted static markup scoped to one shadow root. No scripts or remote content. */
export const steamMarkup = `
<div class="steam-surface">
  <main class="game-shell">
    <div class="topbar layout-title">
      <div class="title-block">
        <h1 aria-label="Steam Punk Star Killer">
          <span class="title-full">Steam Punk Star Killer</span>
          <span class="title-compact" aria-hidden="true">Steam Punk</span>
        </h1>
      </div>
    </div>

    <div class="stat-grid layout-run-stats" aria-label="Run status and pause">
      <div class="stat stat-small"><span>Level</span><strong id="level">1</strong></div>
      <div class="stat stat-small"><span>Balls</span><strong id="balls">1</strong></div>
      <button id="pause" type="button">Pause</button>
    </div>

    <section class="stage-wrap layout-canvas" aria-label="Steam Punk Star Killer game area">
      <div class="canvas-card">
        <span id="chain-status" role="status" hidden></span>
        <div id="chain-meter" role="img" hidden><span></span></div>
        <span id="fuel-status" hidden></span>
        <span id="aim-hint" hidden></span>
        <div id="arcade-reward" role="status" hidden>
          <img src="/assets/steam-punk/neutron-medal-v1.webp" alt="" width="72" height="72" />
          <strong id="arcade-reward-title"></strong>
          <span id="arcade-reward-detail"></span>
        </div>
        <span id="chapter-notice" role="status" hidden></span>
        <canvas
          tabindex="0"
          id="game"
          width="720"
          height="1040"
          aria-label="Aim with pointer or arrow keys, then launch balls to break numbered bricks."
        ></canvas>

        <div class="overlay is-visible" id="overlay">
          <div class="overlay-panel">
            <img class="expedition-hero" src="/assets/steam-punk/expedition-hero-v2.webp"
              alt="Professor Prometheus and crew preparing the brass expedition" width="1536" height="1024" />
            <p class="eyebrow">Ready</p>
            <h2 id="overlay-title">Pull, aim, release</h2>
            <p id="overlay-copy">
              Break numbered bricks before the maze reaches the danger rail. Collect glowing
              upgrades to flood the board with balls.
            </p>
            <ol id="quick-start" class="quick-start" aria-label="Quick start">
              <li><span aria-hidden="true">↗</span><strong>Aim &amp; release</strong><small>Drag on the board · arrows + Space</small></li>
              <li><span aria-hidden="true">✦</span><strong>Break &amp; build</strong><small>Ricochet through bricks · collect upgrades</small></li>
              <li><span aria-hidden="true">⚡</span><strong>Charge &amp; chain</strong><small>Full tank → special → repeat within 5s</small></li>
            </ol>
            <section class="mode-select" id="mode-select" aria-label="Game mode selection">
              <button type="button" class="mode-card is-active" data-game-mode="classic">
                <span>Classic</span>
                <strong>Original arcade run</strong>
              </button>
              <button type="button" class="mode-card" data-game-mode="speed">
                <span>Speed</span>
                <strong>2 minute score rush</strong>
              </button>
              <button type="button" class="mode-card" data-game-mode="timed">
                <span>Timed</span>
                <strong>Rows advance every 3s</strong>
              </button>
            </section>
            <section
              class="scoreboard"
              id="scoreboard"
              aria-label="Steam Punk Star Killer scoreboard"
              hidden
            >
              <div class="scoreboard-hero" aria-hidden="true">
                <span class="scoreboard-gear gear-one"></span>
                <span class="scoreboard-gear gear-two"></span>
                <span class="scoreboard-orbit"></span>
              </div>
              <div class="scoreboard-entry" id="scoreboard-entry">
                <label for="player-name">Optional device label</label>
                <div class="scoreboard-entry-row">
                  <input
                    id="player-name"
                    maxlength="12"
                    autocomplete="off"
                    inputmode="latin"
                    placeholder="ACE"
                  />
                  <button id="save-score" type="button">Save on this device</button>
                </div>
                <button id="clear-records" type="button">Clear device records</button>
                <p id="scoreboard-status" aria-live="polite"></p>
              </div>
              <div
                class="scoreboard-tabs scoreboard-mode-tabs"
                role="tablist"
                aria-label="Scoreboard modes"
              >
                <button
                  type="button"
                  class="scoreboard-tab is-active"
                  data-board-mode="classic"
                  role="tab"
                  aria-selected="true"
                >
                  Classic
                </button>
                <button
                  type="button"
                  class="scoreboard-tab"
                  data-board-mode="speed"
                  role="tab"
                  aria-selected="false"
                >
                  Speed
                </button>
                <button
                  type="button"
                  class="scoreboard-tab"
                  data-board-mode="timed"
                  role="tab"
                  aria-selected="false"
                >
                  Timed
                </button>
              </div>
              <div class="scoreboard-tabs" role="tablist" aria-label="Scoreboard ranges">
                <button
                  type="button"
                  class="scoreboard-tab is-active"
                  data-board-range="all"
                  role="tab"
                  aria-selected="true"
                >
                  All
                </button>
                <button
                  type="button"
                  class="scoreboard-tab"
                  data-board-range="month"
                  role="tab"
                  aria-selected="false"
                >
                  Month
                </button>
                <button
                  type="button"
                  class="scoreboard-tab"
                  data-board-range="week"
                  role="tab"
                  aria-selected="false"
                >
                  Week
                </button>
                <button
                  type="button"
                  class="scoreboard-tab"
                  data-board-range="day"
                  role="tab"
                  aria-selected="false"
                >
                  Day
                </button>
                <button
                  type="button"
                  class="scoreboard-tab"
                  data-board-range="hour"
                  role="tab"
                  aria-selected="false"
                >
                  Hour
                </button>
              </div>
              <ol class="scoreboard-list" id="scoreboard-list" aria-live="polite"></ol>
            </section>
            <button id="primary-action" type="button">Start Run</button>
          </div>
        </div>
      </div>
    </section>

    <div class="score-panel layout-score" aria-live="polite">
      <div class="stat stat-display stat-coins">
        <span>Cash</span><strong id="coins">$0</strong>
      </div>
      <div class="stat stat-display stat-score">
        <span>Score</span><strong id="score">0</strong>
      </div>
    </div>

    <section class="panel-section upgrade-panel layout-upgrades" aria-label="Upgrades">
      <div class="upgrade-header">
        <p class="eyebrow">Upgrades</p>
        <label class="auto-upgrade-toggle" for="auto-upgrade" id="auto-upgrade-label">
          <input id="auto-upgrade" type="checkbox" />
          <span>Auto Upgrade</span>
        </label>
      </div>
      <div class="upgrade-grid">
        <button class="upgrade" data-upgrade="balls" type="button">
          <span>+ Ball</span>
          <strong id="cost-balls">18</strong>
        </button>
        <button class="upgrade" data-upgrade="impact" type="button">
          <span>Bonus</span>
          <strong id="cost-impact">24</strong>
        </button>
        <button class="upgrade" data-upgrade="launchTime" type="button">
          <span>Launch Time</span>
          <strong id="cost-launch-time">30</strong>
        </button>
        <button class="upgrade" data-upgrade="powerupChance" type="button">
          <span>Power Up Chance</span>
          <strong id="cost-powerup-chance">38</strong>
        </button>
      </div>
    </section>

    <aside class="control-panel layout-controls" aria-label="Game controls">
      <div class="panel-section command-panel" id="run-utilities">
        <span id="chapter-name" class="chapter-name">Chapter 1 · The Last Boiler</span>
        <p class="eyebrow">Command Deck</p>
        <div class="button-row">
          <button id="restart" type="button">Restart</button>
        </div>
        <button class="rules-button" id="high-scores-open" type="button">Your records</button>
        <button class="rules-button" id="rules-open" type="button">? Help</button>
      </div>

    </aside>
  </main>

  <section
    class="rules-modal"
    id="rules-modal"
    aria-hidden="true"
    aria-labelledby="rules-title"
    role="dialog"
  >
    <div class="rules-panel">
      <div class="rules-header">
        <div>
          <p class="eyebrow">Guide</p>
          <h2 id="rules-title">Rules, Scoring, Upgrades</h2>
        </div>
        <div class="rules-actions">
          <button class="rules-link-button" id="rules-scores-open" type="button">
            Your records
          </button>
          <button class="icon-button" id="rules-close" type="button" aria-label="Close rules">
            ×
          </button>
        </div>
      </div>

      <div class="rules-grid">
        <article>
          <h3>Objective</h3>
          <p>
            Pick your run, swing the brass star-killer turret into position, and fire upward
            into the numbered hull plates. Keep the board from crushing the danger rail while
            your crew turns every broken brick into cash, glory, and louder machinery.
          </p>
        </article>
        <article>
          <h3>Classic</h3>
          <p>
            The original cabinet challenge. Each volley pushes the maze one row closer to
            disaster. When the Launch Time gauge cools, you may fire again while old shots keep
            ricocheting, but the board still lurches forward. Clear the whole screen and the
            turret snaps back to ready.
          </p>
        </article>
        <article>
          <h3>Speed</h3>
          <p>
            A 2 minute score raid with Auto Upgrade locked on. Every tap feeds your full ball
            rack into the cannon, metered fast enough to feel dangerous and controlled enough to
            keep the machine fair. Bricks that slip past the bottom are docked from your score,
            not your life.
          </p>
          <p>
            Destroy blocks quickly and the board answers with more pressure. Supercharged
            neutron-star collapses buy precious seconds for one more ridiculous scoring run.
          </p>
        </article>
        <article>
          <h3>Timed</h3>
          <p>
            An endless pressure race with Auto Upgrade locked on. The first row drops after 3
            seconds, then the machine keeps getting meaner until the board becomes a brass
            avalanche. The red border means the danger rail is close and your crew is absolutely
            pretending not to panic.
          </p>
        </article>
        <article>
          <h3>Brick Damage</h3>
          <p>
            Every hit bites into a brick's number. Classic shots punch harder at the start,
            while Speed and Timed reward survival, clears, and chaos. Full board clears
            permanently crank up your hit power for the run, and the game keeps the screen
            stocked so the action never goes cold.
          </p>
        </article>
        <article>
          <h3>Neutron Fuel</h3>
          <p>
            Crack neutron stars to fill the lower-left fuel tank. The first deployment costs 5
            fuel packs, and the crew charges a little more each time because apparently boiler
            maintenance is "a business model."
          </p>
          <p>
            When the tank is full, tap it or press N to fire 20 white-hot neutron bombs down
            your current aim line. These shots ignore normal launch traffic and can supercharge
            star collapses into screen-shaking payday moments.
          </p>
        </article>
        <article>
          <h3>Scoring</h3>
          <p>
            Scores climb from hits, destroyed bricks, broken rails, collapsing stars, and
            long-running ball combos. A veteran ball becomes a tiny brass legend: the longer it
            survives, the more its next brick break matters. Classic resets combos on a fresh
            launch; Speed and Timed let hot shots keep their streaks.
          </p>
        </article>
        <article>
          <h3>Earning Cash</h3>
          <p>
            Cash falls out of destroyed bricks, busted rails, glittering orbs, clean board
            clears, and overcooked neutron collapses. Spend it fast or let Auto Upgrade act like
            an overeager quarter-munching engineer.
          </p>
        </article>
        <article>
          <h3>Upgrades</h3>
          <ul>
            <li><strong>+ Ball:</strong> adds one permanent ball to every volley.</li>
            <li><strong>Bonus:</strong> turns better destruction into better cash.</li>
            <li>
              <strong>Launch Time:</strong> cuts the live-volley wait from 20 seconds down to a
              3 second floor, in half-second bites.
            </li>
            <li>
              <strong>Power Up Chance:</strong> makes new waves more likely to arrive carrying
              shiny trouble.
            </li>
            <li>
              <strong>Auto Upgrade:</strong> spends on the cheapest useful upgrade while it is
              enabled.
            </li>
          </ul>
        </article>
        <article>
          <h3>Powerups</h3>
          <ul>
            <li><strong>+1:</strong> adds a permanent ball.</li>
            <li><strong>x:</strong> creates one extra split ball at an angle.</li>
            <li><strong>$:</strong> grants cash immediately.</li>
            <li><strong>!:</strong> pops a local blast through nearby bricks.</li>
            <li><strong>5/10:</strong> rips out the lowest brick rows.</li>
            <li><strong>1/2:</strong> shears every brick's current number in half.</li>
            <li>
              <strong>50:</strong> opens Chaos mode: too many balls, hotter rewards, and the
              sort of engineering choice the droid strongly disapproves of.
            </li>
          </ul>
        </article>
        <article>
          <h3>Maze Rails</h3>
          <p>
            Brass rails bend shots into tunnels, cages, and lucky accidents. Hit them enough and
            they snap like cheap overlord hardware.
          </p>
        </article>
        <article>
          <h3>Ball Physics</h3>
          <p>
            Balls speed up, glance off each other, and curve around neutron gravity. If a shot
            gets trapped in a smug little loop, the machine gives it a nudge back into the
            fight.
          </p>
        </article>
        <article>
          <h3>Gravity Stars</h3>
          <p>
            Neutron stars bend shots toward their furnace cores. Pound one long enough and it
            collapses, blasting nearby bricks, spitting out reward powerups, launching temporary
            burst balls, and loading fuel into the tank.
          </p>
          <p>
            Fire another special within five seconds to earn ×4, then ×8, ×16 and up to ×256 for eight seconds. Speed chains add time, up to 24 bonus seconds per run. Bomb-triggered collapses hit absurdly harder, and chain reactions in one deployment
            can turn a respectable run into arcade folklore.
          </p>
        </article>
        <article>
          <h3>Your records</h3>
          <p>
            Classic, Speed and Timed have separate private records in this myAudience browser.
            Save is optional. Nothing is uploaded, and these records are separate from
            Prometheus. Anyone using this browser can see saved records; Clear removes them.
          </p>
        </article>
        <article>
          <h3>Professor's Log</h3>
          <p>
            Professor Prometheus records each Star Killer catastrophe as a triumph of science.
            Cogsworth assists with enthusiasm, Ledger corrects the casualty math, and the reader
            is invited to witness what happens when the machinery occasionally works.
          </p>
          <p></p>
        </article>
      </div>
    </div>
  </section>
</div>
`;
